import AppBar from '@material-ui/core/AppBar'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import IconButton from '@material-ui/core/IconButton'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import React, { useState } from 'react'
import { compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import { isMobile } from '../../utils'
import { styles } from './styles'
import { CardQrEx } from '../../shared.style'
import { Col, Row } from 'antd'
import g2gImage from '../../assets/images/logo-full-white.png'
import g2gLogo from '../../assets/images/g2g.png'
import QRCode from 'qrcode.react'
import { DownloadOutlined, RedoOutlined } from '@ant-design/icons'
import BackIcon from '@material-ui/icons/ArrowBack'
import { useDeepEffect } from '../../utils/hooks'
import { useDispatch, useSelector } from 'react-redux'
import { fetchLocationByHero } from '../../stores/location'
import { isEmpty } from 'lodash'
const CardContentEx = styled(CardContent)``

export const MyQrCode = ({ me, history: { push } }) => {
  const dispatch = useDispatch()
  const [qrCode, setQrCode] = useState('')
  const { locationList } = useSelector((state) => state.location)
  const CardTitle = (
    <Row gutter={8} type="flex" justify="center">
      <Col>
        <img src={g2gImage} alt="" height={35} />
      </Col>
    </Row>
  )

  async function fetch() {
    await dispatch(fetchLocationByHero(me.id))
  }

  useDeepEffect(() => {
    if (me.heroType === 'SCOOTER') {
      if (!isEmpty(locationList)) {
        const location = locationList[0]
        setQrCode(
          `green2get?heroID=${me.id}&heroType=${me.heroType}&lat=${location.lat}&long=${location.lng}`
        )
      }
    }
  }, [locationList])

  useDeepEffect(() => {
    if (me.heroType === 'SCOOTER') {
      const location = me.locationList[0]
      setQrCode(
        `green2get?heroID=${me.id}&heroType=${me.heroType}&lat=${location.lat}&long=${location.lng}`
      )
    } else {
      setQrCode(`green2get?heroID=${me.id}&heroType=${me.heroType}`)
    }
  }, [])

  function downloadQRCode(e) {
    e.preventDefault()
    const canvas = document.getElementById('qr-gen')
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream')
    const downloadLink = document.createElement('a')
    downloadLink.href = pngUrl
    downloadLink.download = `${qrCode}.png`
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }

  return (
    <React.Fragment>
      <AppBar position="sticky">
        <Toolbar>
          <IconButton
            id="btnMenu"
            style={styles.menuButton}
            color="inherit"
            aria-label="Menu"
            onClick={() => push(`/`)}>
            <BackIcon />
          </IconButton>
          <Typography variant="h6" color="inherit" style={styles.grow}>
            กลับ
          </Typography>
        </Toolbar>
      </AppBar>

      <Card elevation={isMobile ? 0 : 1} square style={{ marginTop: '1rem' }}>
        <CardContentEx>
          <CardQrEx title={CardTitle}>
            <Row>
              <Col span={24}>
                <Row type="flex" justify="center">
                  <QRCode
                    id="qr-gen"
                    size={256}
                    value={qrCode}
                    bgColor={'#ffffff'}
                    fgColor={'#000000'}
                    level={'L'}
                    includeMargin={false}
                    imageSettings={{
                      src: g2gLogo,
                      x: null,
                      y: null,
                      height: 40,
                      width: 40,
                      excavate: true
                    }}
                  />
                </Row>
              </Col>
              <Col span={24}>
                <Row type="flex" justify="center">
                  <span
                    style={{
                      color: '#6ebf4b',
                      fontSize: 24,
                      fontWeight: 'bold'
                    }}>
                    {me.name}
                  </span>
                </Row>
              </Col>
            </Row>
          </CardQrEx>
          <Row
            gutter={24}
            type="flex"
            justify="center"
            style={{ marginTop: '15px' }}>
            <Col>
              <div style={{ cursor: 'pointer' }} onClick={() => fetch()}>
                <Row type="flex" justify="center">
                  <RedoOutlined style={{ fontSize: '18px' }} />
                </Row>
                <Row type="flex" justify="center">
                  <span style={{ fontSize: '16px' }}>รีเฟรช</span>
                </Row>
              </div>
            </Col>
            <Col>
              <div
                style={{ cursor: 'pointer' }}
                onClick={(e) => downloadQRCode(e)}>
                <Row type="flex" justify="center">
                  <DownloadOutlined style={{ fontSize: '18px' }} />
                </Row>
                <Row type="flex" justify="center">
                  <span style={{ fontSize: '16px' }}>บันทึก</span>
                </Row>
              </div>
            </Col>
          </Row>
        </CardContentEx>
      </Card>
    </React.Fragment>
  )
}

export default compose(withRouter)(MyQrCode)



// WEBPACK FOOTER //
// ./src/pages/MyQrCode/index.js